import {useContext} from 'react';
import SettingsContext from 'src/context/SettingsContext';

function test() {

}

export default function useSettings() {
  return useContext(SettingsContext);
}
